import { BsCaretDownFill } from "react-icons/bs";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../redux/postReducer/UserPost";
import { logout } from "../../redux/getReducer/UserSlice";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Cookies from "js-cookie";
import { Modal } from "react-bootstrap";
import Login from '../../pages/Login';
import Register from '../../pages/Registration';
import { FaTachometerAlt, FaMapMarkedAlt } from "react-icons/fa";
import { HiOutlineUserCircle, HiOutlineLogout } from "react-icons/hi";

import { getBaseUrl } from "../../service/apiUrl";
const Auth = () => {
  const { t } = useTranslation();
  const { userInfo, token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const [showlogin, setShowlogin] = useState(false);
  const handleCloseLogin = () => setShowlogin(false);
  const [showReg, setShowReg] = useState(false);
  const handleCloseReg = () => setShowReg(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (token !== null && userInfo === null) {
      dispatch(getUserDetails());
    }
  }, [userInfo, dispatch, token]);

  const clearAllCookies = () => {
    const cookies = Cookies.get();
    for (const cookie in cookies) {
      Cookies.remove(cookie);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.get(`${getBaseUrl()}/logout`, {headers: {Authorization: Cookies.get('token')}});
      dispatch(logout());
      setIsOpen(false);
      navigate("/login");
    } catch (error) {
      dispatch(logout());
      navigate("/login");
    }
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <>
      <div className="my-new-profile-auth-wrapper" ref={dropdownRef}>
        {userInfo ? (
          /* LOGGED IN VIEW */
          <div className="my-new-profile-container" style={{position: 'relative'}}>
            
            <div className={`my-new-profile-card ${isOpen ? 'active' : ''}`} onClick={toggleDropdown}>
              <div className="my-new-profile-avatar-box">
                <img
                  src={userInfo?.user ? userInfo?.user?.ProfilePicture : userInfo?.data?.ProfilePicture}
                  alt="Avatar"
                />
              </div>
              
              <div className="my-new-profile-info" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <p className="my-new-profile-username">
                  {userInfo?.user ? userInfo?.user?.FirstName : userInfo?.data?.FirstName}{" "}
                  {userInfo?.user ? userInfo?.user?.LastName : userInfo?.data?.LastName}
                </p>
                <p className="my-new-profile-label-subtext">{t('Profile')}</p>
              </div>
            </div>

            {/* PROFILE DROPDOWN MENU */}
            {isOpen && (
              <div className="new-dropdown-content" style={{display: 'flex', flexDirection: 'column', right: 0, left: 'auto', padding: '10px 0'}}>
                <Link to="/dashboard" onClick={() => setIsOpen(false)} style={{display: 'flex', alignItems: 'center', gap: '10px'}}> 
                  <FaTachometerAlt />  
                  <span>{t("Dashboard")}</span>
                </Link>
                <Link to="/tracker/#Horseshome" onClick={() => setIsOpen(false)} style={{display: 'flex', alignItems: 'center', gap: '10px'}}> 
                  <FaMapMarkedAlt /> 
                  <span>{t("My Tracker")}</span>
                </Link>
                <Link to="/myprofile" onClick={() => setIsOpen(false)} style={{display: 'flex', alignItems: 'center', gap: '10px'}}> 
                  <HiOutlineUserCircle /> 
                  <span>{t("My Profile")}</span>
                </Link>
                <div style={{height: '1px', backgroundColor: 'rgba(255,255,255,0.1)', margin: '5px 0'}}></div>
                <div onClick={handleLogout} style={{padding: '10px 20px', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px'}}>
                  <HiOutlineLogout /> 
                  <span>{t("Sign Out")}</span>
                </div>
              </div>
            )}
          </div>
        ) : (
          /* LOGGED OUT VIEW */
          <div className="new-auth-buttons" style={{display: 'flex', gap: '10px'}}>
            <button className="new-btn-signin" onClick={() => { clearAllCookies(); navigate('/login'); }}>
              {t("Login")}
            </button>
            <button className="new-btn-register" onClick={() => { clearAllCookies(); navigate('/register'); }}>
              {t("Register")}
            </button>
          </div>
        )}
      </div>

      {/* LOGIN & REGISTRATION MODALS */}
      <Modal show={showlogin} onHide={handleCloseLogin} size="xl" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><Login /></Modal.Body>
      </Modal>

      <Modal show={showReg} onHide={handleCloseReg} size="xl" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><Register /></Modal.Body>
      </Modal>
    </>
  );
};

export default Auth;